var chunkToChildrenMap = {"8125":["4375"],"1319":["4375","3661"],"114":["6478"],"1731":["3257"],"4829":["2175"],"6227":["1471"]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};